import React, { FC } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { ProductEligibility, ProductModel } from '../../../shared/orders/product';
import { UserStateComponent } from '../../components';
import { Fetcher, isResourceError, useFetcher, useUserSafe } from '../../utils';
import { ProductPage } from './productPage';

interface RouterParams {
  id: string;
}
interface ProductLoad {
  product: ProductModel;
  eligibility: ProductEligibility;
}

async function loadProduct(userId: number, productId: number): Promise<ProductLoad> {
  const [product, eligibility] = await Promise.all([
    api.getPublicProductById(productId),
    api.getProductEligibility(userId, productId),
  ]);

  return { product, eligibility };
}

export const ProductPageHOC: FC<RouteComponentProps<RouterParams>> = ({ match: { params } }) => {
  const user = useUserSafe();
  const fetcher = useFetcher(
    async () => await loadProduct(user.id, Number.parseInt(params.id, 10)),
    [user.id, params.id],
  );

  const { data } = fetcher;

  return (
    <UserStateComponent>
      {data ? (
        data.product.category.isStore ? (
          <ProductPage
            eligibility={data.eligibility}
            onBackToCart={fetcher.refresh}
            product={data.product}
          />
        ) : (
          <Redirect to="/store" />
        )
      ) : isResourceError(fetcher.error, 'Product') ? (
        <Redirect to="/store" />
      ) : (
        <Fetcher inline result={fetcher} />
      )}
    </UserStateComponent>
  );
};
